import { useContext } from "react";
import clsx from "clsx";
import { LocaleContext } from "../../app";
import { RatingIcon } from "../rating_icon";
import { StarIcon, StarSelectedIcon, ChevronDownIcon } from "../icons";

export function BoostItem({ option, rating, isSelected, onToggle }) {
  const { translate } = useContext(LocaleContext);
  const full = !!(onToggle && rating);
  return (
    <div className={clsx({ card: full }, "boost-item")}>
      {full && (
        <label
          className={clsx("button boost-item__action", {
            "boost-item__action--selected": isSelected,
          })}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onToggle(e, option.value)}
            className="sr-only"
          />
          {isSelected ? <StarSelectedIcon /> : <StarIcon />}
          <span className="sr-only">
            {isSelected
              ? translate("boost.deselect")
              : translate("boost.select")}
          </span>
        </label>
      )}
      {full && (
        <div className="boost-item__rating">
          <RatingIcon value={rating} />
          {translate(`recommendations.page.scale.${rating}`)}
        </div>
      )}
      <details className="boost-item__details-wrapper">
        <summary className="boost-item__title">
          <span>{option.label}</span>
          <ChevronDownIcon />
        </summary>
        <div className="boost-item__details">
          {translate(`recommendations.${option.value}.title`)}
        </div>
      </details>
    </div>
  );
}
